export interface ItemInterface {
  id: string;
  name: string;
  timeCreated?: number;
  modificationTime?: number;
  timeLastAccess?: number;
  usage?: string;
}
